"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var toDataURL = function toDataURL(url) {
  var log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'OUTRO';
  return new Promise(function (resolve) {
    var xhr = new XMLHttpRequest();

    xhr.onload = function () {
      var reader = new FileReader();

      reader.onloadend = function () {
        window.console.log("LOAD ".concat(log, " ASSET END:"), url);
        resolve(reader.result);
      };

      reader.readAsDataURL(xhr.response);
    };

    xhr.addEventListener('error', function (err) {
      return window.console.log('ERROR', err);
    });
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    window.console.log("LOADING ".concat(log, " ASSET:"), url);
    xhr.send();
  });
};

var _default = toDataURL;
exports.default = _default;